import React from 'react';
import { useEffect } from 'react'
import './dentalblog.css';
import dentalBanner from './../../../../../assets/images/blogs/dentalblog1.jpg';
import { useNavigate } from 'react-router-dom';
import favicon from "./../../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const DentalBlog = () => {

    const handleDownloadPdf = () => {
  const input = document.querySelector('.dentalblog'); // Use the main container class
  
  html2canvas(input, { 
    scale: 2,
    useCORS: true,
    logging: false 
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    
    pdf.save('H-Cura_Dental_Treatment.pdf');
  }).catch(error => {
    console.error('Error generating PDF:', error);
    alert('Failed to generate PDF. Please try again.');
  });
};

  let navigate = useNavigate()
    useEffect(() => {
         document.title = "Simple Daily Habits to Prevent Cavities | Dentist in Bangalore & Chennai";
         const metaDescription = document.querySelector("meta[name='description']");
         if (metaDescription) {
           metaDescription.setAttribute(
             "content",
             "Learn simple daily habits to prevent cavities and protect your smile. Visit H-Cura Dental Clinic in Bangalore & Chennai for expert care and healthy teeth."
           );
         }
         const metaKeywords = document.querySelector("meta[name='keywords']");
         if (metaKeywords) {
           metaKeywords.setAttribute(
             "content",
             "Dental care, cavity prevention, oral hygiene, dentist in Bangalore, dentist in Chennai, dental clinic, healthy teeth, dental tips, dental health, H-Cura Dental Clinic, prevent cavities, dental habits, dental care tips, oral health, dental checkup, dental appointment, dental hygiene routine, best dentist in Bangalore, best dentist in Chennai"
           );
         }
          // Set canonical link
          const existingCanonical = document.querySelector("link[rel='canonical']");
          if (existingCanonical) {
            existingCanonical.setAttribute("href", "https://www.h-cura.com/avoid-cavities-best-dental-clinic");
          } else {
            const canonicalLink = document.createElement("link");
            canonicalLink.setAttribute("rel", "canonical");
            canonicalLink.setAttribute("href", "https://www.h-cura.com/avoid-cavities-best-dental-clinic");
            document.head.appendChild(canonicalLink);
          }
          // Set favicon
       const existingFavicon = document.querySelector("link[rel='icon']");
       if (existingFavicon) {
         existingFavicon.setAttribute("href", favicon);
       } else {
         const faviconLink = document.createElement("link");
         faviconLink.setAttribute("rel", "icon");
         faviconLink.setAttribute("type", "image/x-icon");
         faviconLink.setAttribute("href", favicon);
         document.head.appendChild(faviconLink);
       }
       }, []);
  

  const handleBookAppointment = () => {
    navigate('/bookconsultation'); // Use navigate to redirect to the booking page
  
  };
  return (
    <>
      <div className="dentalblog">
      <div className="dentalblog-banner">
  <img src={dentalBanner} alt="Dental Care Banner" />
  <div className="dentalblog-banner-overlay">
    <h1>Simple Daily Habits to Prevent Cavities</h1>
    <h2>Your Guide to a Healthier Smile</h2>
    <button 
      className="dentalblogbook-appointment-btn" 
      onClick={handleBookAppointment}
    >
      Book Appointment
    </button>
  </div>
</div>

        
        <div className="dentalblog-container">
          <div className="dentalblog-intro">
            <p>Imagine enjoying your favourite ice cream or sipping coffee without that sudden jolt of tooth pain. Sounds wonderful, right? The secret lies in adopting simple daily habits that can prevent cavities and keep your teeth strong for life.</p>
            <p>At H-Cura Multispeciality Clinic, with locations in Jayanagar, Bangalore, and Gerugambakkam, Chennai, we care about your smile as much as you do. Let's dive into practical and science-backed habits to protect your teeth.</p>
          </div>
          
          <div className="dentalblog-section">
            <h2>✅ Why is Cavity Prevention Important?</h2>
            <p>Cavities, also known as tooth decay, are caused by plaque buildup and harmful bacteria in your mouth. If left untreated, they can lead to pain, infections, and even tooth loss.</p>
            <p>For residents in Bangalore and Chennai, our dentists at H-Cura Multispeciality Clinic recommend following these daily oral hygiene habits to keep your smile healthy and cavity-free.</p>
          </div>
          
          <div className="dentalblog-tips">
            <div className="dentalblog-tip-card">
              <h3>🪥 1. Brush Twice Daily with Fluoride Toothpaste</h3>
              <p>Brushing your teeth twice daily is the most effective way to remove plaque and food particles. Use a fluoride toothpaste, as fluoride strengthens your enamel and helps prevent tooth decay.</p>
              <p className="tip-highlight">✅ Pro Tip: If you're in Jayanagar, visit H-Cura's dental care experts to learn the right brushing techniques tailored for you.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>🪡 2. Floss Daily to Clean Between Teeth</h3>
              <p>Brushing alone doesn't clean all the spaces between your teeth. Flossing daily removes plaque from areas your toothbrush can't reach.</p>
              <p className="tip-highlight">✅ Nearby Tip: Schedule a dental checkup in Valasaravakkam, Chennai, to get a professional flossing demo from our dental team.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>🍬 3. Chew Sugar-Free or Xylitol Gum After Meals</h3>
              <p>Chewing xylitol gum after meals increases saliva production, neutralizes harmful acids, and helps prevent cavities naturally.</p>
              <p className="tip-highlight">✅ Bonus Tip: Keep sugarless gum handy, especially when you're out exploring Bangalore's cafes or Chennai's street food joints.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>💧 4. Drink Water for Better Oral Health</h3>
              <p>Water isn't just for hydration—it's your mouth's natural cleanser. Drinking water rinses away food particles, maintains saliva flow, and supports oral care habits.</p>
              <p className="tip-highlight">✅ Local Tip: If you're looking for personalized hydration tips for dry mouth, book a visit to our dental clinic in Gerugambakkam, Chennai.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>🚫 5. Limit Sugar Intake and Acidic Foods</h3>
              <p>Sugary and acidic foods are the leading causes of cavities. A healthy diet for teeth includes fresh fruits, vegetables, and calcium-rich foods to strengthen enamel.</p>
              <p className="tip-highlight">✅ Small Change, Big Impact: Replace soft drinks with water or coconut water, especially during Bangalore summers.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>🪥 6. Use Mouthwash for Extra Protection</h3>
              <p>Adding a fluoride or antimicrobial mouthwash to your routine provides additional mouthwash benefits, killing bacteria and reducing plaque.</p>
              <p className="tip-highlight">✅ Pro Tip: Ask our team in Jayanagar, Bangalore, which mouthwash is right for you during your next visit.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>🦷 7. Visit Your Dentist for Regular Checkups</h3>
              <p>Even with a great routine, you still need a professional touch. Schedule a dental checkup every six months for teeth cleaning and to apply sealants if needed.</p>
              <p>At H-Cura Multispeciality Clinic, with branches in Jayanagar, Bangalore, and Valasaravakkam, Chennai, our dentists help you stay ahead of cavities with gentle, personalized care.</p>
            </div>
          </div>
          
          <div className="dentalblog-cta">
            <h2>📞 Book Your Appointment Now</h2>
            <p>👉 Call: <a href="tel:+918870001377">+91 88700 01377</a></p>
            <p>📍 Visit us in Bangalore (Jayanagar) or Chennai (Tambaram , Gerugambakkam & Valasaravakkam)</p>
          </div>
          
          <div className="dentalblog-summary">
            <h2>🌟 Quick Summary: Your Cavity-Fighting Checklist</h2>
            <ul>
              <li>✅ Brush twice daily with fluoride toothpaste</li>
              <li>✅ Floss and use mouthwash regularly</li>
              <li>✅ Chew xylitol gum after meals</li>
              <li>✅ Drink water and eat a healthy diet for teeth</li>
              <li>✅ Schedule regular dental checkups in Bangalore or Chennai</li>
            </ul>
            <p>By practicing these simple daily habits, you're not just preventing cavities—you're investing in a confident, pain-free smile.</p>
          </div>
          
          <div className="dentalblog-testimonials">
            <h2>❤️ Why H-Cura is the Best Choice for Your Dental Health</h2>
            <p>At H-Cura Multispeciality Clinic, our expert dentists provide preventive dental care in Bangalore and Chennai, ensuring your smile stays healthy for years.</p>
            <div className="testimonial-container">
              <div className="testimonial">
                <p>💬 "I visited H-Cura in Jayanagar for a dental checkup, and their tips helped me avoid cavities completely!" – A happy patient from Bangalore</p>
              </div>
              <div className="testimonial">
                <p>💬 "Best dentist near me in Valasaravakkam! I highly recommend H-Cura for cavity prevention." – A patient from Chennai</p>
              </div>
            </div>
          </div>
        </div>
      </div>

       {/* <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Blog as PDF
            </button>
          </div> */}
    </>
  );
};

export default DentalBlog;
